module.exports = __webpack_public_path__ + "static/media/30.3f8332d8.jpg";